import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';
import '@fortawesome/fontawesome-free/css/all.css'
Vue.use(Vuetify, {
  directives: {
    Ripple
  }
});


export default new Vuetify({
  // theme: {
  //   dark: true,
  // },
  icons: {
    iconfont: 'mdi',
  },
});